// extracted by mini-css-extract-plugin
export var displayNone = "_qv-6";
export var imgContainer = "_qv-2";
export var overflowHidden = "_qv-3";
export var productInfoCardButtonContainer = "_qv-5";
export var productTitleText = "_qv-4";
export var rightArrow = "_qv-1";
export var rightArrowContainer = "_qv-0";